<template>
  <ButtonComponent
      id="request_google_login"
      :variant="$props.variant"
      :text="buttonText[$props.type][$props.lang]"
      :image="'https://cdn.systemico.net/abc/icons/google.svg'"
      @click="loginWithGoogle()"
      class="text-center"
      style="display: inline; min-width:280px;">
  </ButtonComponent>
  <!--../../../../assets/images/logo__google.svg-->
</template>
<script>
import ButtonComponent from './ButtonComponent.vue'
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'
export default {
  name: 'ButtonGoogleLogin',
  components: {
    ButtonComponent
  },
  props: {
    variant: {
      type: String,
      variant: 'secondary'
    },
    lang: {
      type: String,
      default: 'EN'
    },
    type: {
      type: String,
      default: 'LOGIN'
    },
    urlcallback: {
      type: String,
      default: ''
    },

  },
  data () {
    return {
      buttonText: {
        LOGIN: {
          EN: 'Sign in <b>with Google</b>',
          ES: 'Iniciar <b>con Google</b'
        },
        SIGNUP: {
          EN: 'Sign up <b>with Google</b>',
          ES: 'Regístrate <b>con Google</b'
        }
      }
    }
  },
  beforeMount () {
    if (this.lang !== 'EN' && this.lang !== 'ES') {
      this.lang = 'EN'
    }
  },
  methods: {
    /* loginWithGoogle () {
      // REDIRECT SITE
      window.location.href = '/api/glogin/validate';
    }, */
    async loginWithGoogle() {
      const protocolo = window.location.protocol;       // 'http:' o 'https:'
      const host = window.location.hostname;            // 'subdominio.dominio.com'
      const urlBase = `${protocolo}//${host}`;

      const url = urlBase+'/api/glogin/validate'+this.$props.urlcallback //'https://eteamer.net/api/glogin/validate?callback=eteamer://auth/callback'
      if (Capacitor.getPlatform() === 'web') {
        // Abre con window.open en navegador
        //window.open(url, '_blank')
        window.location.href = '/api/glogin/validate';
      } else {
        // Abre con Capacitor Browser en iOS/Android
        await Browser.open({ url })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../variables.scss";
</style>
